/*eslint-disable*/
import { TextField, withStyles } from "@material-ui/core";
import React from "react";

const styles = theme => ({
  textField: {
    width: "100%",
    marginTop: 0,
    marginBottom: 0
  }
});

const grandSeperator = val => {
  val = val.replace(/,/g, "").replace(/ /g, "");
  let parsed = parseFloat(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString().replace(/,/g, " ");
  } else {
    return val;
  }
};

class GrandInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    event.preventDefault();

    if (this.props.input.onChange && !this.props.readOnly) {
      this.props.input.onChange(event);
      this.props.input.onBlur(event);
    }
  };

  

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.meta.touched ||
      nextProps.input.value !== this.props.input.value ||
      nextProps.p_value !== this.props.p_value
    ) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  render() {
    this.props.meta.valid = false;

    let trySubmit = this.props.checkValidation ? true : false;

    const {
      meta: { touched, error, warning }
    } = this.props;

    let lValue = this.props.fixedValue
      ? this.props.fixedValue
      : this.props.input.value;

    //default lOutputComponent
    let lOutputComponent = (
      <TextField
        onChange={this.handleChange}
        id={this.props.input.name}
        value={grandSeperator(lValue)}
        label={this.props.label}
        className={this.props.classes.textField}
        margin="normal"
      />
    );

    if (lValue) {
      lOutputComponent = (
        <TextField
          onChange={this.handleChange}
          id={this.props.input.name}
          value={grandSeperator(lValue)}
          label={this.props.label}
          className={this.props.classes.textField}
          margin="normal"
          error={
            error && error.length > 0 && touched
              ? true
              : error && error.length > 0 && trySubmit
                ? true
                : false
          }
          helperText={(error && touched) || (error && trySubmit) ? error : null}
        />
      );
    } else {
      lOutputComponent = (
        <TextField
          onChange={this.handleChange}
          id={this.props.input.name}
          value={grandSeperator(lValue)}
          label={this.props.label}
          className={this.props.classes.textField}
          margin="normal"
          error={
            error && error.length > 0 && touched
              ? true
              : error && error.length > 0 && trySubmit
                ? true
                : false
          }
          helperText={
            (error && error.length > 0 && touched) ||
            (error && error.length > 0 && trySubmit)
              ? error
              : null
          }
        />
      );
    }

    return <div>{lOutputComponent}</div>;
  }
}

export default withStyles(styles)(GrandInput);



// WEBPACK FOOTER //
// ./src/components/Wrappers/materialUIWrappers/components/GrandInput.js